import { render, staticRenderFns } from "./Lang.vue?vue&type=template&id=369494c1&scoped=true&"
import script from "./Lang.vue?vue&type=script&lang=ts&"
export * from "./Lang.vue?vue&type=script&lang=ts&"
import style0 from "./Lang.vue?vue&type=style&index=0&id=369494c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369494c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('369494c1')) {
      api.createRecord('369494c1', component.options)
    } else {
      api.reload('369494c1', component.options)
    }
    module.hot.accept("./Lang.vue?vue&type=template&id=369494c1&scoped=true&", function () {
      api.rerender('369494c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Select/Lang.vue"
export default component.exports